import { emptyView } from "#/assets/cart";
import type { TUser } from "@monta/utils";
import { Icon } from "@monta/design-system";
import { UsersTypeEnum } from "#/constants";
import { useMontaNavigate } from "@monta/router-react";
import styles from "./emptyView.module.scss";

interface LoginInfo {
  loginInfo: TUser | undefined;
}

const getPlpUrl = (loginInfo: LoginInfo["loginInfo"]) => {
  if (!loginInfo) return null;

  const { typeId, subTypeId } = loginInfo;

  if (typeId == UsersTypeEnum.STUDENT) return "/all-packages/student/";
  if (typeId == UsersTypeEnum.DEAN) {
    if ([UsersTypeEnum.ADVISOR, UsersTypeEnum.DEAN].includes(subTypeId)) {
      return "/all-packages/school/";
    }

    if (subTypeId == UsersTypeEnum.TEACHER) {
      return "/all-packages/teacher/";
    }
  }

  return null;
};

const EmptyView = (props: LoginInfo) => {
  const { loginInfo } = props;
  const navigate = useMontaNavigate();

  const plpUrl = getPlpUrl(loginInfo);

  return (
    <div className={styles["main-container"]}>
      <div className={styles["container"]}>
        <div className={styles["cart-Picture"]}>
          <img src={emptyView} alt="empty-cart" />
        </div>
        <div className={styles["cart-title"]}>سبد خرید شما خالی است!</div>
        <button
          onClick={() => {
            if (plpUrl) navigate(plpUrl, { baseUrl: "LANDING_URL" });
            else navigate("/", { baseUrl: "LANDING_URL" });
          }}
          className={styles["cart-button"]}
        >
          <span>بازگشت به صفحه {plpUrl ? "محصولات" : "اصلی"}</span>
          <Icon icon={"mi-Arrow-Left"} size={1} />
        </button>
      </div>
    </div>
  );
};

export default EmptyView;
